// extracted by mini-css-extract-plugin
export default {"container":"ThemeProvider_container__SXQrc"};